import { render, staticRenderFns } from "./DualHeatingDevicePanel.vue?vue&type=template&id=f27c536a&scoped=true&lang=pug&"
import script from "./DualHeatingDevicePanel.vue?vue&type=script&lang=ts&"
export * from "./DualHeatingDevicePanel.vue?vue&type=script&lang=ts&"
import style0 from "./DualHeatingDevicePanel.vue?vue&type=style&index=0&id=f27c536a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27c536a",
  null
  
)

export default component.exports